export interface FluxoContent {
	title: string;
	monthlyEvolution: string;
	growthText: string;
	currencyPrefix: string;
	cashless: {
		subtitle: string;
		totalLabel: string;
		ticketLabel: string;
		checkInsLabel: string;
	};
	ficha: {
		subtitle: string;
		totalLabel: string;
		ticketLabel: string;
		transactionsLabel: string;
	};
}

export const fluxoContent: FluxoContent = {
	title: "FLUXO & FATURAMENTO",
	monthlyEvolution: "Evolução Mensal",
	growthText: "+{{percentage}}% vs {{year}}",
	currencyPrefix: "R$ ",
	cashless: {
		subtitle: "Faturamento e Ticket médio por pessoa pagante",
		totalLabel: "Pessoas pagantes*",
		ticketLabel: "Gasto médio anual por pessoa pagante*",
		checkInsLabel: "Check-ins realizados*",
	},
	ficha: {
		subtitle: "Faturamento e Ticket médio por pedido",
		totalLabel: "Produtos vendidos",
		ticketLabel: "Ticket médio por pedido",
		transactionsLabel: "Pedidos realizadas",
	},
};
